import { render } from "./AppDialog.vue?vue&type=template&id=59a0e12d&scoped=true"
import script from "./AppDialog.vue?vue&type=script&lang=js"
export * from "./AppDialog.vue?vue&type=script&lang=js"

import "./AppDialog.vue?vue&type=style&index=0&id=59a0e12d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59a0e12d"]])

export default __exports__